export function globalPriceSetupExists(priceSetups) {
    return !!priceSetups?.find((priceSetup) => !priceSetup.countries || priceSetup.countries?.length === 0);
}

export function globalPriceSetupIsNotLastSetup(priceSetups) {
    const index = priceSetups?.findIndex((priceSetup) => priceSetup.countries?.length === 0);
    return !(index === -1 || index === priceSetups?.length - 1);
}

export function isExchangeDisabled(priceSetup) {
    return priceSetup?.disableExchanges;
}

export function isExchangesComplaintDisabled(priceSetup) {
    return priceSetup?.disableExchangesComplaint;
}

export function isComplaintsDisabled(priceSetup) {
    return priceSetup?.disableComplaints;
}

export function getReturnHandlingCost(priceSetup) {
    return priceSetup?.returnHandlingCost;
}

export function getExchangeCost(priceSetup) {
    return priceSetup?.exchangeCost;
}

export function getReturnHandlingFreeAboveTotalAmount(priceSetup) {
    return priceSetup?.returnsFreeAboveTotalAmount;
}

export function getFailedDeliveryCost(priceSetup) {
    return priceSetup?.failedDeliveryCost;
}

export function getDisabledExchanges(priceSetup) {
    return priceSetup?.disableExchanges;
}

export function getReturnTimeLimit(priceSetup) {
    return priceSetup?.returnTimeLimit;
}

export function getShipmentMethodId({ shipmentSolution, shipmentSolutionOptions }) {
    const foundShipmentMethod = shipmentSolutionOptions?.find(({ type, carrier }) => {
        return shipmentSolution?.type === type && (shipmentSolution?.carrier ? shipmentSolution?.carrier === carrier : true);
    });

    return foundShipmentMethod?.id;
}

export function getShipmentCost(shipmentSolution) {
    return shipmentSolution?.cost;
}

export function getReturnAddressId({ shipmentSolution, priceList }) {
    return shipmentSolution?.returnAddress?.id || priceList?.returnAddress?.id;
}

export function getReturnAddressComplaintId({ shipmentSolution, priceList }) {
    return shipmentSolution?.returnAddressComplaint?.id || priceList?.returnAddressComplaint?.id;
}

export function getReturnAddressC2cId({ shipmentSolution, priceList }) {
    return shipmentSolution?.returnAddressC2c?.id || priceList?.returnAddressC2c?.id;
}

export function getActiveOnFulfillmentsFrom(shipmentSolution) {
    return shipmentSolution?.activeOnFulfillmentsFrom;
}

export function getActiveOnFulfillmentsTo(shipmentSolution) {
    return shipmentSolution?.activeOnFulfillmentsTo;
}

export function getActiveOnFulfillmentCarriers(shipmentSolution) {
    return shipmentSolution?.activeOnFulfillmentCarriers;
}
